import Axios from 'axios';

Axios.defaults.withCredentials = true;
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

Axios.interceptors.request.use(function(config) {
    var token = common.cacheToken();
    if (token) {
        config.headers.common['x-access-token'] = token.split('_')[0] + '_ms';
    }
    return config;
}, function(error) {
    console.error(error);
    return error;
});

var qs = require('qs');

// const def_content_type = 'application/x-www-form-urlencoded;charset=UTF-8';
const def_content_type = 'application/x-www-form-urlencoded';

const common = function() {};

common.getBasePath = function() {
    var location = (window.location + '').split('/');
    return location[0] + '//' + location[2] + '/';
}

common.convert_url = function(_url) {
    return _url;
};

common.cache = function() {
    if (arguments.length == 0) {
        localStorage.clear();
    } else if (arguments.length == 1) {
        return JSON.parse(localStorage.getItem(arguments[0]) || '{}');
    } else if (arguments.length == 2) {
        localStorage.setItem(arguments[0], JSON.stringify(arguments[1]));
    }
};

common.cacheStr = function() {
    if (arguments.length == 0) {
        localStorage.clear();
    } else if (arguments.length == 1) {
        return localStorage.getItem(arguments[0]) || '';
    } else if (arguments.length == 2) {
        localStorage.setItem(arguments[0], arguments[1]);
    }
};

common.get_session = function(_name) {
    var _object = common.cache(_name)
    return _object;
};

common.user_info = function() {
    if (arguments.length == 0) {
        return common.cache('user_info');
    }
    common.cache('user_info', arguments[0]);
};

common.cacheToken = function() {
    if (arguments.length == 0) {
        return common.cacheStr('_token');
    }
    common.cacheStr('_token', arguments[0]);
};

common.enum_config_init = function() {
    common.my_ajax({
        url: '/enumConstant/findEnumConstant',
        success: function(response) {
            common.cache('enum_config', response.item);
        }
    });
};
common.enum_config = function() {
    var config = common.cache('enum_config');
    if (0 == arguments.length) {
        return config;
    } else {
        return config[arguments[0]];
    }
};

common.upload_content_type = 'multipart/form-data';

let loadingInstance = null;
common.my_ajax = function(params) {
    var _this = this;
    var lastRequest = common.cache('last-request');
    var currentTime = new Date().getTime();
    if (lastRequest.url == params.url && lastRequest.repeatKey == params.repeatKey && currentTime - lastRequest.time <
        1000) {
        console.log(lastRequest.url + '重复请求' + params.repeatKey);
        return false;
    }
    common.cache('last-request', {
        url: params.url,
        repeatKey: params.repeatKey,
        time: currentTime
    });
    var data = params.data || {};
    if (typeof data != 'string' && !params.contentType) {
        data = qs.stringify(data);
    }
    var showLoaded = false;
    if (params.url.match(/(save|update|delete)/gi)) {
        showLoaded = true;
    }
    if (showLoaded) {
        loadingInstance = _this.$element.Loading.service({
            text: '正在处理，请稍后'
        });
    }
    Axios({
        baseURL: config.hostUrl,
        withCredentials: false,
        url: common.convert_url(params.url || ''),
        method: params.type || 'POST',
        data: data,
        headers: {
            'Content-Type': params.contentType || def_content_type
        }
    }).then(response => {
        var data = response.data;
        if (showLoaded && loadingInstance) {
            loadingInstance.close();
            loadingInstance = null;
        }
        if (data.success) {
            (params.success || function() {})(data);
        } else if ('no_user' == data.msg ||
            'no_verify' == data.msg ||
            'error_verify' == data.msg ||
            'authority' == data.msg) {
            (params.failure || function() {
                _this.$router.push({ name: 'login' });
            })();
        } else if ('user_valid' == data.msg) {
            _this.$element.Message({
                showClose: true,
                message: '账号或密码错误',
                type: 'error'
            });
        } else if (params.failure) {
            params.failure(data);
        } else if (data.msg) {
            _this.$element.Message({
                showClose: true,
                message: data.msg,
                type: 'error'
            });
            //_this.$element.Message.error(data.msg);
        } else {
            console.error(data);
        }
    }).catch(error => {
        if (showLoaded && loadingInstance) {
            loadingInstance.close();
            loadingInstance = null;
        }
        console.error(error);
    });
};
common.ajaxRequest = common.my_ajax;
common.refreshUserMenuAuth = function(_userId) {
    common.my_ajax({
        url: '/localUser/getUserMenuAuth',
        data:{userId:_userId},
        success: res => {
            common.cache("menus",res.item.menus);
            common.cache("menusList",res.item.menusList);
        }
    });
};
common.goRouterLink = function(_obj){
    this.$router.push(_obj);
}
export default common;